import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import WorkReportView from '../components/WorkReportView';
import PasswordField from '../components/PasswordField';

export default function WorkReportPage() {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [enteredPw, setEnteredPw] = useState('');
  const [needsPw, setNeedsPw] = useState(false);

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['work-report', token, enteredPw],
    queryFn: () => axios.get(`/api/reports/work-report/${token}${enteredPw ? '?password=' + encodeURIComponent(enteredPw) : ''}`).then(r => r.data),
    retry: false,
  });

  useEffect(() => {
    if (isError && error?.response?.data?.requiresPassword) setNeedsPw(true);
  }, [isError, error]);

  if (isLoading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <div style={{ width: 32, height: 32, border: '3px solid #DDE1E9', borderTopColor: '#073E81', borderRadius: '50%', animation: 'spin .7s linear infinite' }} />
    </div>
  );

  if (needsPw && !data) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', padding: 20 }}>
      <div style={{ background: '#fff', border: '1px solid #DDE1E9', borderRadius: 10, padding: 28, width: '100%', maxWidth: 340 }}>
        <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>Password required</div>
        <div style={{ fontSize: 13, color: '#5A6478', marginBottom: 16 }}>This report is password protected.</div>
        <PasswordField value={password} onChange={e => setPassword(e.target.value)}
          placeholder="Enter password"
          style={{ marginBottom: 10 }}
          inputStyle={{ padding: '8px 10px', border: '1px solid #DDE1E9', borderRadius: 6, fontSize: 13 }} />
        <button onClick={() => { setEnteredPw(password); setNeedsPw(false); }}
          style={{ width: '100%', padding: 10, background: '#073E81', color: '#fff', border: 'none', borderRadius: 6, fontSize: 14, cursor: 'pointer' }}>
          View report
        </button>
      </div>
    </div>
  );

  if (isError) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', flexDirection: 'column', gap: 10 }}>
      <div style={{ fontSize: 20, fontWeight: 700 }}>Link expired or not found</div>
      <div style={{ fontSize: 13, color: '#5A6478' }}>This report link has expired or is invalid. Please request a new link.</div>
    </div>
  );

  return <WorkReportView data={data} />;
}
